import { Text } from '@mantine/core';
import { type ReactElement, type ReactNode } from 'react';

interface Props {
  type?: 'primary' | 'secondary' | 'tertiary';
  size?: 'md' | 'lg' | 'xl';
  children: ReactNode;
}

export const Heading = (props: Props): ReactElement => {
  const { type = 'primary', size = 'md', children } = props;

  const fwMap = {
    primary: 800,
    secondary: 700,
    tertiary: 600,
  };

  return (
    <Text fw={fwMap[type]} size={size}>
      {children}
    </Text>
  );
};
